import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SwUpdate } from '@angular/service-worker';
import { ClassToggleService } from '@coreui/angular-pro';
import { ApiService } from 'src/app/service/api/api.service';

@Component({
  selector: 'app-home-header',
  templateUrl: './home-header.component.html',
  styleUrls: ['./home-header.component.scss']
})
export class HomeHeaderComponent implements OnInit {

  @Input() sidebarId: string = "sidebar1";

  public newMessages = new Array(4);
  public newTasks = new Array(5);
  public newNotifications = new Array(5);

  public themeSwitch = new UntypedFormGroup({
    themeSwitchRadio: new UntypedFormControl('light'),
  });

  pendingReclamations: any[] = [];
  pendingReclamationCount = 0;

  // ── Recherche mairie ──────────────────────────────────────────
  id_mairie: string = "";
  mairie_search: string = "";
  mairies_filtrees: any[] = [];
  show_mairie_dropdown = false;

  constructor(
    private classToggler: ClassToggleService,
    public api: ApiService,
    private swUpdate: SwUpdate
  ) {}

  ngOnInit() {
     console.log('🔍 les_mairies =', JSON.stringify(this.api.infos.les_mairies, null, 2));
    const categorie = (this.api.infos?.current_mairie?.categorie || '').toLowerCase();
    const role = (
      this.api.infos?.agent?.role
      || this.api.infos?.token?.token_decoded?.taf_data?.role
      || this.api.infos?.token?.user_connected?.role
      || ''
    ).toLowerCase();

    const is_perception_context = (
      categorie === 'perception'
      || categorie === 'tresor'
      || role.includes('percept')
      || role.includes('tresor')
    );
    const manually_selected = this.api.infos?.mairie_manually_selected;

    if (is_perception_context) {
      this.id_mairie = manually_selected
        ? (this.api.infos.current_mairie?.id_mairie || '')
        : '';
    } else {
      this.id_mairie = this.api.infos.current_mairie?.id_mairie || '';
    }

    // Init liste filtrée avec toutes les mairies
    this.mairies_filtrees = this.api.infos.les_mairies || [];
    this.refresh_reclamations_badge();
  }

  // ── Recherche mairie ──────────────────────────────────────────
  on_mairie_search() {
    const search = (this.mairie_search || '').toLowerCase().trim();
    this.mairies_filtrees = (this.api.infos.les_mairies || []).filter(
      (m: any) => !search || (m.nom || '').toLowerCase().includes(search)
    );
    this.show_mairie_dropdown = true;
  }

  get_mairie_label(): string {
    if (!this.id_mairie) return '';
    const found = (this.api.infos.les_mairies || []).find(
      (m: any) => String(m.id_mairie) === String(this.id_mairie)
    );
    return found?.nom || '';
  }

select_mairie(id: any, event: MouseEvent) {
    event.preventDefault();
    console.log('🔵 select_mairie appelé avec id =', id);
    this.id_mairie    = id ? String(id) : '';
    this.mairie_search = this.id_mairie ? this.get_mairie_label() : '';
    this.show_mairie_dropdown = false;
    this.mairie_change();
}

  on_blur_mairie() {
    // Petit délai pour laisser le mousedown se déclencher avant le blur
    setTimeout(() => {
      this.show_mairie_dropdown = false;
      // Remettre le label correct si l'utilisateur a tapé sans sélectionner
      this.mairie_search = this.id_mairie ? this.get_mairie_label() : '';
      this.mairies_filtrees = this.api.infos.les_mairies || [];
    }, 200);
  }

async mairie_change() {
  console.log('🟢 mairie_change, this.id_mairie =', this.id_mairie);
  if (!this.id_mairie || this.id_mairie === '') {
    console.log('🟡 branche "toutes les mairies"');
    this.api.infos.current_mairie           = this.api.infos.les_mairies[0];
    this.api.infos.mairie_manually_selected = false;
    this.api.infos.filtre_toutes_mairies    = true;
  } else {
    console.log('🟠 branche mairie spécifique');
    this.api.infos.current_mairie           = (this.api.infos.les_mairies || []).find(
      (one: any) => String(one.id_mairie) === String(this.id_mairie)
    );
    console.log('🟠 mairie trouvée =', this.api.infos.current_mairie);
    this.api.infos.mairie_manually_selected = true;
    this.api.infos.filtre_toutes_mairies    = false;
  }
  console.log('⚪ avant save, mairie_manually_selected =', this.api.infos.mairie_manually_selected);
  await this.api.save_on_local_storage("infos", this.api.infos);
  window.location.reload();
}
get cible_role(): string {
    const categorie = (this.api.infos?.current_mairie?.categorie || '').toLowerCase();
    if (categorie === 'mairie' || categorie.includes('mair')) return 'mairie';
    if (categorie === 'perception' || categorie === 'tresor' || categorie.includes('percept')) return 'perception';
    return '';
  }

  refresh_reclamations_badge() {
    if (!this.api.can('/home/reclamation')) {
      this.pendingReclamations     = [];
      this.pendingReclamationCount = 0;
      return;
    }
    this.api.taf_post('reclamation/get_notifications', {}, (rep: any) => {
      if (rep?.status) {
        if (this.cible_role === 'mairie') {
          this.pendingReclamationCount = +rep.nb_attente_mairie || 0;
        } else if (this.cible_role === 'perception') {
          this.pendingReclamationCount = +rep.nb_attente_perception || 0;
        } else {
          this.pendingReclamationCount = +rep.total_attente || 0;
        }
      }
    }, () => {});

    const filtres: any = { etat_reclamation: 0 };
    if (this.cible_role) filtres.cible_reclamation = this.cible_role;

    this.api.taf_post_object('reclamation/get_2', filtres, (rep: any) => {
      if (rep?.status && Array.isArray(rep.data)) {
        this.pendingReclamations = rep.data;
      } else {
        this.pendingReclamations = [];
      }
    }, () => { this.pendingReclamations = []; });
  }

  // ── Divers ────────────────────────────────────────────────────
  setTheme(value: string): void {
    this.themeSwitch.setValue({ themeSwitchRadio: value });
    this.classToggler.toggle('body', 'dark-theme');
  }

  get_titre() {
    const user = this.api.infos.agent;
    switch (user?.id_privilege) {
      case 2:  return { titre: user?.prenom + " " + (user.nom ?? ''), description: "Collecteur" };
      case 3:  return { titre: user?.prenom + " " + (user.nom ?? ''), description: "Régisseur" };
      case 4:  return { titre: user?.prenom + " " + (user.nom ?? ''), description: "Conseil Municipal" };
      case 5:  return { titre: user?.prenom + " " + (user.nom ?? ''), description: "Trésor publique" };
      case 6:  return { titre: user?.prenom + " " + (user.nom ?? ''), description: "Recenseur" };
      case 7:  return { titre: user?.prenom + " " + (user.nom ?? ''), description: "Administrateur" };
      default: return { titre: '', description: '' };
    }
  }

  checkForUpdates(): void {
    this.swUpdate.checkForUpdate();
  }

  toggleSidebar() {
    this.api.show_sidebar = !this.api.show_sidebar;
    this.api.save_on_local_storage("show_sidebar", this.api.show_sidebar);
  }
}